import React from 'react';
import { CModal, ModalOverlay } from '@televet/kibble-ui/build/chakra';
import SendToDeveloperModalContent from './SendToDeveloperModalContent';

interface ISendToDeveloperModal {
  isOpen: boolean;
  onClose: () => void;
}

const SendToDeveloperModal = ({ isOpen, onClose }: ISendToDeveloperModal): JSX.Element => {
  return (
    <CModal isOpen={isOpen} isCentered size="xl" onClose={onClose}>
      <ModalOverlay />
      <SendToDeveloperModalContent onClose={onClose} />
    </CModal>
  );
};
export default SendToDeveloperModal;
